module.exports = __webpack_public_path__ + "img/sfq-h5.3cce1d44.png";